import { httpRequest } from "../../http";

export type EntryDurationOverride = {
  subtype: string;
  total_days: number;
  active_days: number;
};

export type EntryDurationResponse = {
  entry_id: number;
  total_days: number;
  active_days: number;
  overrides: EntryDurationOverride[];
};

export class CmdGetEntryDuration {
  async run(entryId: number): Promise<EntryDurationResponse> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/schedules/entries/${entryId}/duration`;
    return await httpRequest<EntryDurationResponse>(url, { method: "GET" });
  }
}
